import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type {
  ListCustomerInteractionsToolInput,
  ListCustomerInteractionsToolOutput,
} from "@repo/app-types/entities/copilot";
import { renderPlural } from "@repo/app-types/helpers/utilities";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

/**
 * @deprecated This tool has been removed. Component retained for historical thread rendering.
 */
export const ListCustomerInteractionsTool: ToolComponent<
  ListCustomerInteractionsToolInput,
  ListCustomerInteractionsToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Retrieving customer interactions...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while retrieving customer interactions";
    }

    return renderPlural(props.output.customer_interactions.length, {
      zero: "No customer interactions found",
      one: "Retrieved 1 customer interaction",
      other: (count) =>
        `Retrieved ${count.toLocaleString()} customer interactions`,
    });
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
